
export const initDashTileTemplates = (templates) => ({
    type:"DASHTILETEMPLATES_INIT",
    templates,
});